"use client"

import Carousel from "@/components/common/Carousel"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Fragment, useMemo } from "react"
import HotelGoodPriceItem from "./HotelGoodPriceItem"
import { flattenHotelGoodPriceProducts } from "./flattenHotelGoodPriceProducts"

const HotelGoodPricesDesktop = ({ data }: { data: any[] }) => {
  const isDesktop = useIsDesktop()

  const sortedProducts = useMemo(
    () => flattenHotelGoodPriceProducts(data),
    [data],
  )

  if (!isDesktop) {
    return <Fragment />
  }

  return (
    <Carousel
      options={{
        groupCells: true,
        contain: true,
        pageDots: false,
        prevNextButtons: true
      }}
    >
      {sortedProducts.map((product) => (
        <HotelGoodPriceItem key={product.__key} product={product} />
      ))}
    </Carousel>
  )
}

export default HotelGoodPricesDesktop
